<template>
  <v-row
    class="mx-0 my-0"
    no-gutters
    dense
  >
    <v-col
      sm="3"
      xs="3"
      md="3"
      lg="3"
      xl="3"
      class="px-1 py-0"
    >
      <label class="cmr-book-form-label">Lead PAX Name</label>
      <SimpleTextInput
        v-model="bookingForm.booking.business_customer_name"
        :error="bookingForm.errors.business_customer_name"
      />
    </v-col>
    <v-col
      sm="3"
      xs="3"
      md="3"
      lg="3"
      xl="3"
      class="px-0 py-0"
    >
      <label class="cmr-book-form-label">Contact No.</label>
      <a
        v-if="bookingForm.booking.business_customer_number != null && bookingForm.booking.business_customer_number != ''"
        :href="'tel:' + formatNumber(bookingForm.booking.business_customer_number)"
      >
        <v-btn
          x-small
          fab
          elevation="0"
          color="blue"
          class="small-icon-bg"
        >
          <v-icon
            small
            color="white"
          >
            phone
          </v-icon>
        </v-btn>
      </a>
      <SimpleTextInput
        v-model="bookingForm.booking.business_customer_number"
        :error="bookingForm.errors.business_customer_number"

      />
    </v-col>
    <v-col
      sm="3"
      xs="3"
      md="3"
      lg="3"
      xl="3"
      class="px-1 py-0"
    >
      <label class="cmr-book-form-label">Email</label>
      <SimpleTextInput
        v-model="bookingForm.booking.business_customer_email"
        :error="bookingForm.errors.business_customer_email"
      />
    </v-col>
    <v-col
      sm="3"
      xs="3"
      md="3"
      lg="3"
      xl="3"
      class="px-0 py-0"
    >
      <label class="cmr-book-form-label">REF</label>
      <SimpleTextInput
        v-model="bookingForm.booking.business_customer_reference"
        :error="bookingForm.errors.business_customer_reference"

      />
    </v-col>
    <v-col
      sm="3"
      xs="3"
      md="3"
      lg="3"
      xl="3"
      class="px-1 py-0"
    >
      <label class="cmr-book-form-label">Authorized By</label>
      <SimpleTextInput
        v-if="!hideAuthorizedBy"
        v-model="bookingForm.booking.authorized_by"
        :error="bookingForm.errors.authorized_by"
      />
    </v-col>
  </v-row>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";

import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "BusinessCustomerDetailsInput",
  components: {
    BookingDateInput,
    SimpleTextInput
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    hideAuthorizedBy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
